import { login_children } from "dependencies/login/index.js"
// import icon from "../../../../assets/images/leftMenu/basePortal/icon_search.png"
let icon = "icon-portal-login"
export default {
  name: "登录框",
  id: "",
  thumbnail: icon,
  type: "cxSystemLogin",
  componentType:"emptyLayoutComponent",
  // typeId: "E074D974B810464C",
  typeId: "",
  children: login_children
}
